/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { buildValidations, validator } from 'ember-cp-validations';

export default buildValidations({
  blocks: {
    description: 'Contents',
    validators: [
      validator('blocks-not-empty', {
        message: 'Finish writing your email',
      }),
      validator('no-empty-code-blocks'),
    ],
  },
  senderId: {
    description: 'Sender',
    validators: [validator('email-sender-domain-authenticated')],
  },
  subjectBlocks: {
    description: 'Subject blocks',
    validators: [
      validator('blocks-not-empty', {
        message: 'Subject should not be empty',
      }),
    ],
  },
});
